var React = require('react');

module.exports = function () {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "12",
    viewBox: "0 0 12 12"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M11.14 12V9.14S9.29 11.9 5.81 11.9C2.61 11.9.01 9.43.01 6h.86c0 2.57 2.22 5.04 4.94 5.04 1.8 0 3.81-.99 4.69-2.54l-2.79-.04v-.75H12V12h-.86zM6.2.96c-1.8 0-3.82.99-4.69 2.54l2.78.04v.75H0V0h.86v2.86S2.72.1 6.2.1C9.39.1 12 2.57 12 6h-.86C11.14 3.43 8.92.96 6.2.96z"
  }));
};